import { useBreakpointValue } from "@chakra-ui/react";
import { AnimatePresence, motion } from "framer-motion";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SignOut } from "../../redux/auth/AuthSlice";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

function Layout({ children }) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isOpen, setIsOpen] = useState(!isMobile);


  const dispatch = useDispatch();
  const navigate = useNavigate();

  const variants = {
    initial: { opacity: 0, x: -100 },
    expanded: { marginLeft: "250px", opacity: 1, x: 0 },
    collapsed: { marginLeft: "100px", opacity: 1, x: 0 },
    mobile: { marginLeft: "0px", opacity: 1, x: 0 },
    transition: { duration: 0.5 },
    exit: { opacity: 0, x: 100 },
  };

  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);
  const { user, userData } = useSelector((state) => state?.auth);

  const currentTime = Date.now();
  //logout from current system on expiry
  if (isLoggedIn) {
    const decodedUser = jwtDecode(user);
    const toKenExpiry = decodedUser?.expires;
    if (toKenExpiry < currentTime) {
      // navigate("/signin")
      window.location.href = "/signin";
      localStorage.removeItem("cu_user");
    }
  }

  //logout from current system on expire
  if (isLoggedIn) {
    if (userData?.exp) {
      // navigate("/signin")
      window.location.href = "/signin";
      localStorage.removeItem("cu_user");
    }
  }

  useEffect(() => {
    setIsOpen(!isMobile);
  }, [isMobile]);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };


  return (
    <>
      <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} isMobile={isMobile} />
      <Topbar
        toggleSidebar={toggleSidebar}
        isMobile={isMobile}
        isSidebarOpen={isOpen}
      />
      <AnimatePresence>
        <motion.main
          initial={"initial"}
          exit={"exit"}
          animate={isMobile ? "mobile" : isOpen ? "expanded" : "collapsed"}
          variants={variants}
          style={{ padding: "0 1rem 0 0.75rem" }}
        >
          {children}
        </motion.main>
      </AnimatePresence>
    </>
  );
}

export default Layout;
